import { QueryClient } from "@tanstack/react-query";

// Conservative defaults: no surprise refetches on window focus (matches
// the app's previous fetch-on-login behavior); transient failures retry below.
export function isTransient(error) {
  const status = error?.response?.status;
  return status == null || status >= 500;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // The API sleeps when idle and takes a couple of seconds to wake; a
      // request that lands in that window fails with no response (the
      // browser reports it as a CORS error) or a 503. Retry those with
      // backoff; never retry a real 4xx.
      retry: (failureCount, error) => failureCount < 4 && isTransient(error),
      retryDelay: (attempt) => Math.min(800 * 2 ** attempt, 4000),
    },
  },
});
